import { FunctionComponent, useEffect } from 'react';
import { useBranding } from './useBranding';

/** Keeps the browser tab title and favicon in line with the brand (index.html ships the cBridge ones) */
export const BrandingSync: FunctionComponent = () => {
  const { title, iconHref } = useBranding();

  useEffect(() => {
    document.title = title;

    const icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (icon) {
      icon.href = iconHref;
    }
  }, [title, iconHref]);

  return null;
};
